export const getPostIdFromUrl = () => {
    if (typeof window !== 'undefined' && window.location.hash) {
        return window.location.hash.replace('#', '')
    }
}
